import { FormState } from '../../models';
import { basicInfo } from './basic-info';
import { dialogActions } from './dialog-actions';
import { EdgeDxLocationCardState } from './models';

export const edgeDxFormState = (state: EdgeDxLocationCardState): FormState => {
    return {
        config: {
            info: {
                id: 'edge-dx-location-config',
                title: 'EDGE-DX Location Configuration',
            },
            sections: [basicInfo(state), dialogActions(state)],
        },
    };
};
